/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ScheduleDaysContainer, ScheduleDaysText } from '../../AllJobs.Style';

export interface IWeeklyScheduleProps {
  t: (key: string) => string;
  selectedDays: string[];
  handleDayClick: (day: string) => void;
  daysStyle?: any;
  numericToDayMap: string[];
  showLabel?: boolean;
}

const WeeklySchedule: React.FC<IWeeklyScheduleProps> = ({
  t,
  selectedDays,
  handleDayClick,
  daysStyle,
  numericToDayMap,
  showLabel,
}) => {
  const theme = useTheme();

  return (
    <>
      {showLabel && <ScheduleDaysText>{t('jobManagement:serviceDays')}</ScheduleDaysText>}
      <ScheduleDaysContainer
        sx={{
          marginBottom: !showLabel ? '2.5rem' : '0.5rem',
          gap: !showLabel ? '2.5rem' : '0.3rem',
          justifyContent: !showLabel ? 'flex-start' : 'center',
        }}>
        {numericToDayMap.map((day) => (
          <Box
            key={day}
            onClick={() => handleDayClick(day)}
            bgcolor={selectedDays.includes(day) ? theme.palette.secondary.dark : ''}
            fontWeight={selectedDays.includes(day) ? theme.typography.fontWeightBold : theme.typography.fontWeightLight}
            sx={daysStyle}>
            {day}
          </Box>
        ))}
      </ScheduleDaysContainer>
    </>
  );
};

export default WeeklySchedule;
